define("shared/components/shared/appstore-links", ["exports", "@ember/component", "@ember/debug", "@ember/object/computed", "@ember/service", "@ember/utils", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _debug, _computed, _service, _utils, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/debug",0,"@ember/object/computed",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="tOB--device__downloads u--row u--row--noCollapse">
    <div class="u--col__5">
      <img class="img--appstore--qr qa--setup_qr_code" src={{this.qrCodeUrl}} />
    </div>
    <div class="u--col__7">
      <Shared::Link
        @href="https://apps.apple.com/us/app/later-social-media-scheduler/id784907999"
        @text=""
        class="img--appstore--apple"
        id="app_store"
        title={{t "account.devices.ios_icon_alt"}}
      >
        &nbsp;
      </Shared::Link>
      <Shared::Link
        @href="https://play.google.com/store/apps/details?id=me.latergram.latergramme"
        @text=""
        class="img--appstore--google"
        id="app_store"
        title={{t "account.devices.android_icon_alt"}}
      >
        &nbsp;
      </Shared::Link>
    </div>
  </div>
  */
  {
    "id": "DlrPpD53",
    "block": "[[[10,0],[14,0,\"tOB--device__downloads u--row u--row--noCollapse\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"u--col__5\"],[12],[1,\"\\n    \"],[10,\"img\"],[14,0,\"img--appstore--qr qa--setup_qr_code\"],[15,\"src\",[30,0,[\"qrCodeUrl\"]]],[12],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"u--col__7\"],[12],[1,\"\\n    \"],[8,[39,0],[[24,0,\"img--appstore--apple\"],[24,1,\"app_store\"],[16,\"title\",[28,[37,1],[\"account.devices.ios_icon_alt\"],null]]],[[\"@href\",\"@text\"],[\"https://apps.apple.com/us/app/later-social-media-scheduler/id784907999\",\"\"]],[[\"default\"],[[[[1,\"\\n       \\n    \"]],[]]]]],[1,\"\\n    \"],[8,[39,0],[[24,0,\"img--appstore--google\"],[24,1,\"app_store\"],[16,\"title\",[28,[37,1],[\"account.devices.android_icon_alt\"],null]]],[[\"@href\",\"@text\"],[\"https://play.google.com/store/apps/details?id=me.latergram.latergramme\",\"\"]],[[\"default\"],[[[[1,\"\\n       \\n    \"]],[]]]]],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[],false,[\"shared/link\",\"t\"]]",
    "moduleName": "shared/components/shared/appstore-links.hbs",
    "isStrictMode": false
  });
  let AppstoreLinksComponent = _exports.default = (_dec = (0, _computed.reads)('auth.currentUserModel.id'), (_class = class AppstoreLinksComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "currentUserId", _descriptor2, this);
    }
    get qrCodeUrl() {
      (false && !((0, _utils.isPresent)(this.args.origin)) && (0, _debug.assert)('The `@origin` argument is required', (0, _utils.isPresent)(this.args.origin)));
      const envOrigin = window.location.origin;
      return `${envOrigin}/devices/qr_code.png?origin=${this.args.origin}&page=later&user_id=${this.currentUserId}`;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "currentUserId", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, AppstoreLinksComponent);
});